
import * as products from './products';
import * as cms from './cms';
import * as users from './users';
import * as orders from './orders';
import * as chat from './chat';
import * as newsletter from './newsletter';
import * as emails from './emails';
import * as invoices from './invoices';
import * as categories from './categories';
import * as shopContent from './shopContent';
import * as stats from './stats';
import * as withdrawals from './withdrawals';
import * as live from './live';

export const db = {
    ...products,
    ...cms,
    ...users,
    ...orders,
    ...chat,
    ...newsletter,
    ...emails,
    ...invoices,
    ...categories,
    ...shopContent,
    ...stats,
    ...withdrawals,
    ...live
};
